import { render, staticRenderFns } from "./MetricsAdmin.vue?vue&type=template&id=5316bc8f&scoped=true"
import script from "./MetricsAdmin.vue?vue&type=script&lang=js"
export * from "./MetricsAdmin.vue?vue&type=script&lang=js"
import style0 from "./MetricsAdmin.vue?vue&type=style&index=0&id=5316bc8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5316bc8f",
  null
  
)

export default component.exports